import {
  UploadImageField,
  LoaderButton
} from 'components/molecules'
import { WEB_URL_CONSTANTS } from 'constants/web-url-constants'
import { Form, Formik } from 'formik'
import ProductCollectionAsyncMultiselectField from 'domains/product-collection/molecules/async-multiselect-field'
import PropTypes from 'prop-types'
import React from 'react'
import { Col, Row } from 'reactstrap'

const propTypes = {
  featured_seller: PropTypes.shape({
    seller: PropTypes.shape({
      id       : PropTypes.number,
      name     : PropTypes.string,
      username : PropTypes.string,
      url_key  : PropTypes.string
    }),
    favourite_brand: PropTypes.shape({
      hero_image_url : PropTypes.string,
      collection_id  : PropTypes.number
    }),
    main_page_thumbnail_image_url     : PropTypes.string,
    inspired_look_thumbnail_image_url : PropTypes.string
  }),
  favouriteBrandHeroImage       : PropTypes.object,
  mainPageThumbnailImage        : PropTypes.object,
  inspiredLookThumbnailImage    : PropTypes.object,
  setFavouriteBrandHeroImage    : PropTypes.func,
  setMainPageThumbnailImage     : PropTypes.func,
  setInspiredLookThumbnailImage : PropTypes.func,
  handleSubmitForm              : PropTypes.func.isRequired
}

const defaultProps = {
  featured_seller: {
    seller: {
      id       : 0,
      name     : '',
      username : '',
      url_key  : ''
    },
    favourite_brand: {
      hero_image_url : '',
      collection_id  : 0
    },
    main_page_thumbnail_image_url     : '',
    inspired_look_thumbnail_image_url : ''
  },
  favouriteBrandHeroImage       : new Blob(),
  mainPageThumbnailImage        : new Blob(),
  inspiredLookThumbnailImage    : new Blob(),
  setFavouriteBrandHeroImage    : () => {},
  setMainPageThumbnailImage     : () => {},
  setInspiredLookThumbnailImage : () => {},
  handleSubmitForm              : () => {}
}

/**
 * Form to edit CMS Featured Seller Favourite Brand
 */

const CmsFeaturedSellerFavouriteBrandForm = ({
  featured_seller,
  favouriteBrandHeroImage,
  mainPageThumbnailImage,
  inspiredLookThumbnailImage,
  setFavouriteBrandHeroImage,
  setMainPageThumbnailImage,
  setInspiredLookThumbnailImage,
  handleSubmitForm
}) =>  (
  <Formik
    enableReinitialize={ true }
    initialValues={{
      collection_id   : featured_seller.favourite_brand.collection_id,
      featured_seller : featured_seller
    }}
    onSubmit={ handleSubmitForm }
  >
    {
      (formikBag) => (
        <>

          <h3>
            { 'Go to Featured Seller Favourite Brand page ' }
            <a
              className='text-primary'
              href={ `${WEB_URL_CONSTANTS.HOMEPAGE}/featured-sellers/${formikBag.values.featured_seller.seller.url_key}/favourite-brands` }
              target='_blank' rel='noopener noreferrer'
            >
              { 'here' }
            </a>
          </h3>

          <Form>
            <UploadImageField
              id='output-favourite-brand-hero-image'
              label='Cover Image'
              required={ true }
              image={ favouriteBrandHeroImage }
              initialImageSrc={ featured_seller.favourite_brand.hero_image_url }
              setValue={ (input) => {
                setFavouriteBrandHeroImage(input)
              } }
            />

            <ProductCollectionAsyncMultiselectField
              name={ 'collection_id' }
              label='Product Collection'
              placeholder='Select Collection'
              isMultiple={ false }
              required={ true }
            />

            <UploadImageField
              id='output-main-page-thumbnail-image'
              label='Main Page Thumbnail Image'
              image={ mainPageThumbnailImage }
              required={ true }
              initialImageSrc={ featured_seller.main_page_thumbnail_image_url }
              setValue={ (input) => {
                setMainPageThumbnailImage(input)
              } }
            />

            <UploadImageField
              id='output-inspired-look-thumbnail-image'
              label='Inspired Look Thumbnail Image'
              image={ inspiredLookThumbnailImage }
              required={ true }
              initialImageSrc={ featured_seller.inspired_look_thumbnail_image_url }
              setValue={ (input) => {
                setInspiredLookThumbnailImage(input)
              } }
            />

            <Row >
              <Col>
                <LoaderButton
                  className='float-right'
                  color='success'
                  isLoading={ formikBag.isSubmitting }
                  onClick={ formikBag.submitForm }
                  text={ 'Save' }
                />
              </Col>
            </Row>

          </Form>
        </>
      )
    }
  </Formik>
)

CmsFeaturedSellerFavouriteBrandForm.propTypes    = propTypes
CmsFeaturedSellerFavouriteBrandForm.defaultProps = defaultProps

export default CmsFeaturedSellerFavouriteBrandForm
